import { createContext } from "react";
import { User } from "../core/interfaces/User";

export const UserContext = createContext<User>({});
